import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { AddIntegrationRequest } from '@/types/request/AddIntegrationRequest';
import { queryClient } from '@/main.tsx';

const useIntegrationAdd = () => {
  const client = supabaseClient;

  const mutationFn = async (request: AddIntegrationRequest) => {
    return addIntegration(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integrations'] });
    },
  });
};

export default useIntegrationAdd;

async function addIntegration(client: SupabaseClient, request: AddIntegrationRequest): Promise<void> {
  const { data, error } = await client.from('integrations').insert(request).select('id').maybeSingle();

  if (error) throw new Error(error.message);
  if (!data) throw new Error('Failed to add Integration.');

  return;
}
